import { reportService } from '@/common/api.service'

const initialStates = {
    status: 'loading',
    statistics: {
        total_transactions: 0,
        total_wage: 0,
        unsettled_balance: 0,
        settled_amount: 0,
        settled_balance: 0,
    },
    gatewayStatistics: {
        monthly_transactions: 0,
        daily_transactions: 0,
        total_transactions: 0,
        unsettled_balance: 0,
        settled_balance: 0,
        total_wage: 0,
    },
    userCoreAccountingStatistics: {
        settled_amount: 0,
        total_wage: 0,
        total_balance: 0,
        total_transactions: 0,
    },
    userStarshopAccountingStatistics: {
        settled_amount: 0,
        total_wage: 0,
        total_balance: 0,
        total_transactions: 0,
    },
    userLoginStatistics: {
        user_level: 0,
        created_at: 0,
        last_ip_login: 0,
        last_update: 0,
    },
    userStatistics: {
        accounting_info: {
            settled_amount: 0,
            total_wage: 0,
            total_balance: 0,
            total_transactions: 0,
        },
        login_info: {
            user_level: 0,
            created_at: 0,
            last_ip_login: 0,
            last_update: 0,
        }
    },
    pfTerminalStatistics:{
        total_transactions: 0,
        total_wage: 0,
        total_bank_wage: 0,
        settled_balance: 0,
    },
    taxExports: {},
    shaparakExcels: [],
    officialFactor: {},
}

const mutations = {
    loading(state) {
        state.status = 'loading'
        state.statistics = []
        state.userStatistics = []
        state.userLoginStatistics = []
        state.userCoreAccountingStatistics = []
        state.userStarshopAccountingStatistics = []
        state.gatewayStatistics = []
        state.pfTerminalStatistics = []
    },
    success(state, statistics) {
        state.status    = 'success'
        state.statistics = statistics
    },
    gatewayStatistics(state, gatewayStatistics) {
       state.status = 'gateway-success'
       state.gatewayStatistics = gatewayStatistics
    },
    userCoreAccountingStatistics(state, userCoreAccountingStatistics) {        
        state.status = 'user-success'
        state.userCoreAccountingStatistics = userCoreAccountingStatistics
    },
    userStarshopAccountingStatistics(state, userStarshopAccountingStatistics) {
        state.status = 'user-status'
        state.userStarshopAccountingStatistics = userStarshopAccountingStatistics
    },
    userLoginStatistics(state, userLoginStatistics) {
        state.status = 'user-success'
        state.userLoginStatistics = userLoginStatistics
    },
    pfTerminalStatistics(state, pfTerminalStatistics) {
       state.status = 'pf-terminal-success'
       state.pfTerminalStatistics = pfTerminalStatistics
    },
    taxExports(state, taxExports) {
        state.status = 'success'
        state.taxExports = taxExports
    },

    shaparakExcels(state, excels) {
        state.status = 'success'
        state.shaparakExcels = excels
    },

    officialFactor(state, officialFactor) {
        state.status = 'success'
        state.officialFactor = officialFactor
    },

    fail(state) {
        state.status    = 'fail'
        state.statistics = []
    },
}

const getters = {
    status: state => state.status,
    statistics: state => state.statistics,
    gatewayStatistics: state => state.gatewayStatistics,
    userCoreAccountingStatistics: state => state.userCoreAccountingStatistics,
    userStarshopAccountingStatistics: state => state.userStarshopAccountingStatistics,
    userLoginStatistics: state => state.userLoginStatistics,
    pfTerminalStatistics: state => state.pfTerminalStatistics,
    taxExports: state => state.taxExports,
    shaparakExcels: state => state.shaparakExcels,
    officialFactor: state => state.officialFactor
}

const actions = {
    fetchGatewaysStatistics({commit}, query) {
        commit('loading')
        return reportService.fetchGatewaysStatistics(query)
            .then(response => {
                commit('success', response.data.data)
            })
    },

    fetchUsersStatistics({commit}, query) {
        commit('loading')
        return reportService.fetchUsersStatistics(query)
            .then(response => {
                commit('success', response.data.data)
            })
    },

    fetchPfTerminalsDetails({commit}, query) {
        commit('loading')
        return reportService.fetchPfTerminalsStatistics(query)
            .then(response => {
                commit('pfTerminalStatistics', response.data.data)
            })
    },

    gatewayDetails({commit}, {params, is_starshop = false}) {
        commit ('loading')
        return reportService.gatewayDetails(params, is_starshop).then(response => {
            commit('gatewayStatistics', response.data.data)
            })
    },

    fetchTaxExports({commit}) {
        commit ('loading')
        return reportService.fetchTaxExports().then(response => {
            commit ('taxExports', response.data.data)
        });
    },

    fetchShaparakExcels({commit}) {
        commit ('loading')
        return reportService.getShaparakExcelList().then(response => {
            commit ('shaparakExcels', response.data.data)
        });
    },

    fetchUserOfficialFactor({commit}, query) {
        commit ('loading')
        return reportService.fetchUserOfficialFactor(query).then(response => {
            commit ('officialFactor', response.data.data)
        });
    },

    userCoreAccountingInfo({commit}, hashid) {        
        commit ('loading')
        return reportService.userCoreAccountingInfo(hashid)
            .then(response => {
                commit('userCoreAccountingStatistics', response.data.data)
            })
    },

    userStarshopAccountingInfo({commit}, hashid) {        
        commit ('loading')
        return reportService.userStarshopAccountingInfo(hashid, true)
            .then(response => {
                commit('userStarshopAccountingStatistics', response.data.data)
            })
    },

    userLogin({commit}, hashid) {
        commit ('loading')
        return reportService.userLoginInfo(hashid)
            .then(response => {
                commit('userLoginStatistics', response.data.data)
            })
    }

}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}